export const KEY_CODES = {
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  BACKSPACE: 8,
  TAB: 9
};

export const PROPERTY_LOCATIONS = [
  {
    state: "Massachusetts",
    abbrev: "MA",
    src: "../../svg/MA.svg",
    disabled: false
  },
  {
    state: "Maine",
    abbrev: "ME",
    src: "../../svg/ME.svg",
    disabled: false
  },
  {
    state: "New Hampshire",
    abbrev: "NH",
    src: "../../svg/NH.svg",
    disabled: false
  },
  {
    state: "Vermont",
    abbrev: "VT",
    src: "../../svg/VT.svg",
    disabled: false
  },
  {
    state: "Connecticut",
    abbrev: "CT",
    src: "../../svg/CT.svg",
    disabled: false
  },
  {
    state: "Rhode Island",
    abbrev: "RI",
    src: "../../svg/RI.svg",
    disabled: false
  },
  {
    state: "New York",
    abbrev: "NY",
    src: "../../svg/NY.svg",
    disabled: true
  }
];

export const STATES = {
  AK: "Alaska",
  AL: "Alabama",
  AR: "Arkansas",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  MD: "Maryland",
  ME: "Maine",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
  DC: "Washington, D.C"
};

export const STATTII = {
  CLOSED_DUPLICATE: "CLOSED - DUPLICATE"
}